import HttpService from "./HttpService";
const API_ENDPOINT = "/employee-account-detail-edit";

const EmployeeAccountDetailService = {
  async getDetails(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default EmployeeAccountDetailService;
